import * as React from "react";
import { useEffect, useState } from "react";
import { groupBy } from "lodash";
import { PaymentType } from "../../../../../../../../../Wrap/Constants/Enums/Apply/PaymentType";
import { ProductOverviewPaymentsInAction } from "../../Action/ProductOverviewPaymentsInAction";
import { ClientAccount } from "../../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { Table } from "../../../../../../../../Shared/Table/Table";
import { PaymentPayer } from "../../../../../../../../../Wrap/Constants/Enums/Payments/PaymentPayer";
import AriaTooltip from "../../../../../../../../Shared/Tooltip/AriaTooltip";
import { PaymentPayerMapper, TransferStatusMapper } from "../../Constant/Content";
import { MoneyDisplayHelper } from "../../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { JsonDateParser } from "../../../../../../../../../react-core/Utils/JsonDateParser";
import { Lightbox, LightboxType } from "../../../../../../../../../react-core/Html/Components/Lightbox";
import { SubAccountType } from "../../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SubAccountTypeHelper } from "../../../../../Common/Helpers/SubAccountTypeHelper";
import { Action } from "../../../../../../../Actions/Action";
import { CashPaymentTypeQuery } from "../../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery";
import { CashPaymentFrequencyQuery } from "../../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { CashPayment } from "../../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { PaymentSource } from "../../../../../../../../../Wrap/Constants/Enums/Domain/PaymentSource";
import { PaymentStatus } from "../../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/PaymentStatus";
import { InstructionType } from "../../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/InstructionType";
import { StaticUrls } from "../../../../../../../Resoures/StaticUrls";
import { SelectRegularPaymentPop } from "../../../Common/SelectRegularPaymentPop";
import { UserClaim } from "../../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../../../../../Shared/Permission/PermissionHelper";
import { Permission } from "../../../../../../../../Shared/Permission/Permission";
import { InvestorType } from "../../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";

interface IActiveInstructionsProps {
    subAccountHierarchyId: string;
    activeTransferIn: any;
    SubaccountType?: SubAccountType;
    headAccount: ClientAccount;
}

const splitData = (data) => {
    const result = { single: null, regular: null };
    const groupedData = groupBy(data, "Type");
    Object.keys(groupedData).forEach((key) => {
        if (key === PaymentType.Single.toString()) {
            result.single = groupedData[key];
        } else if (key === PaymentType.Regular.toString()) {
            result.regular = groupedData[key];
        }
    });
    return result;
};

export const ActiveInstructions = (props: IActiveInstructionsProps) => {
    const [regularPayment, setRegularPayment] = useState(null);
    const [singlePayment, setSinglePayment] = useState(null);
    const [selectClientRegular, setSelectClientRegular] = useState<CashPayment[]>([]);
    const [lightBoxInfo, setLightBoxInfo] = useState({
        isShow: false,
        amount: null,
        frequency: null,
        bankAccount: null,
        nextPaymentDate: null,
        cashEntryId: null,
    });

    const editRegularLink = (cashEntryId: number) => {
        return StaticUrls.RegularPaymentUrl(
            props.SubaccountType.toString(),
            props.headAccount?.HeadClAccountId,
            props.headAccount?.HierarchyId,
            props.subAccountHierarchyId,
            "edit",
            cashEntryId
        );
    };

    useEffect(() => {
        ProductOverviewPaymentsInAction.getPendingProductPaymentsIn(props.subAccountHierarchyId, (data) => {
            const splitDatum = splitData(data);
            setSinglePayment(splitDatum.single);
            setRegularPayment(splitDatum.regular);
        });
    }, [props.subAccountHierarchyId]);

    return (
        <>
            <div className="ad d1">
                <h1 className="sr-only">Payment in</h1>
                <h2 className="mb-22">Active instructions</h2>

                {!SubAccountTypeHelper.isBond(props.SubaccountType) && (
                    <div className="d-flex f-direction-column">
                        <div className="row mb-5">
                            <div className="col-fluid col-middle">
                                <h3 className="mb-0">Current regular payment instructions</h3>
                            </div>
                            {regularPayment?.length > 0 &&
                                checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                                    <div className="col-auto col-middle">
                                        <button
                                            type="button"
                                            title="Edit"
                                            className="edit-circle-icon-button label-sr-only"
                                            onClick={() => {
                                                Action.getRegularPaymentCashEntry(
                                                    props.subAccountHierarchyId,
                                                    CashPaymentTypeQuery.Deposit,
                                                    CashPaymentFrequencyQuery.Regular,
                                                    (result) => {
                                                        const clientRegularPayment = result.filter(
                                                            (cashEntry) =>
                                                                (cashEntry.Source == PaymentSource.Employee ||
                                                                    cashEntry.Source == PaymentSource.NotSpecified) &&
                                                                cashEntry.InstructionType == InstructionType.Standing &&
                                                                cashEntry.Status == PaymentStatus.Authorised
                                                        );
                                                        if (clientRegularPayment.length > 1) {
                                                            setSelectClientRegular(clientRegularPayment);
                                                        } else {
                                                            window.location.assign(
                                                                editRegularLink(clientRegularPayment[0]?.BatchId)
                                                            );
                                                        }
                                                    }
                                                );
                                            }}
                                        >
                                            <span className="icon" aria-hidden="true"></span>
                                            <span className="text">Edit current regular payment instructions</span>
                                        </button>

                                        {/*<button type="button" className="edit-circle-icon-button"><span className="icon"></span><span className="sr-only">Edit Current regular payment instructions</span></button>*/}
                                    </div>
                                )}
                        </div>
                        {regularPayment?.length > 0 ? (
                            <div className="panel-subtle pt-0 pb-10 mb-40">
                                <Table
                                    cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                    data={regularPayment}
                                    col={[
                                        {
                                            title: "Payer",
                                            key: "Payer",
                                            thInnerCss: "sr-only",
                                            render: (data) => {
                                                if (
                                                    data === null ||
                                                    data === "" ||
                                                    data === PaymentPayer.NotSpecified
                                                ) {
                                                    return (
                                                        <AriaTooltip
                                                            cssWrapper="is-underlined-text no-border-radius"
                                                            buttonText={"No recorded Payee"}
                                                            showCloseButton={true}
                                                        >
                                                            We don’t have a record of the payee for this transaction
                                                        </AriaTooltip>
                                                    );
                                                } else {
                                                    return PaymentPayerMapper[data];
                                                }
                                            },
                                        },
                                        {
                                            title: "Amount",
                                            tdCssWrapper: "cell-right",
                                            thCssWrapper: "cell-right",
                                            key: "Amount",
                                            render: (data) => {
                                                return MoneyDisplayHelper.FromatMoneyDisplay(
                                                    data,
                                                    CurrencyCode.GBP,
                                                    true,
                                                    2
                                                );
                                            },
                                        },
                                        {
                                            title: "Frequency",
                                            key: "Frequency",
                                        },
                                        {
                                            title: "Paid from",
                                            key: "PaidFrom",
                                        },
                                        {
                                            title: "Next Payment",
                                            key: "NextPaymentDate",
                                            render: (data) => {
                                                return JsonDateParser.getFormatDate(data, "yyyy-MM-dd");
                                            },
                                        },
                                        {
                                            title: "Investment allocation",
                                            key: "Id",
                                            render: (data, row) => {
                                                return checkPermission(UserClaim.AdviserPortalDluOrdersCanView) ? (
                                                    <a
                                                        href={`/clients/orders/orders.aspx?claccountid=${props.headAccount?.HeadClAccountId}&SearchBatchType=Standing`}
                                                        className="hyperlink"
                                                    >
                                                        View
                                                    </a>
                                                ) : null;
                                            },
                                        },
                                        {
                                            title: "",
                                            key: "Id",
                                            render: (data, row) => {
                                                return (
                                                    <button
                                                        className="select-toggle"
                                                        onClick={() => {
                                                            setLightBoxInfo({
                                                                isShow: true,
                                                                amount: row.Amount,
                                                                frequency: row.Frequency,
                                                                bankAccount: row.PaidFrom,
                                                                nextPaymentDate: row.NextPaymentDate,
                                                                cashEntryId: row.CashEntryId,
                                                            });
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                );
                                            },
                                        },
                                    ]}
                                />
                            </div>
                        ) : (
                            <div className="panel-subtle mb-40">
                                <span>No regular payment(s) currently set up for this client</span>
                            </div>
                        )}
                    </div>
                )}

                <div className="row wide-gutter">
                    <div className="col-12 col-sm-fluid col-equalise">
                        <div className="d-flex f-direction-column">
                            <h3 className="mb-5">Expected single payments(s)</h3>
                            <div className="panel-subtle pt-0 pb-10 mb-20 f-grow-1">
                                <div>
                                    {singlePayment?.length > 0 ? (
                                        <Table
                                            cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                            data={singlePayment}
                                            col={[
                                                {
                                                    title: "Payer",
                                                    key: "Payer",
                                                    render: (data) => {
                                                        if (
                                                            data === null ||
                                                            data === "" ||
                                                            data === PaymentPayer.NotSpecified
                                                        ) {
                                                            return (
                                                                <AriaTooltip
                                                                    cssWrapper="is-underlined-text no-border-radius"
                                                                    buttonText={"No recorded Payee"}
                                                                    showCloseButton={true}
                                                                >
                                                                    We don’t have a record of the payee for this
                                                                    transaction
                                                                </AriaTooltip>
                                                            );
                                                        } else {
                                                            return PaymentPayerMapper[data];
                                                        }
                                                    },
                                                },
                                                {
                                                    title: "Amount",
                                                    key: "Amount",
                                                    render: (data) => {
                                                        return MoneyDisplayHelper.FromatMoneyDisplay(
                                                            data,
                                                            CurrencyCode.GBP,
                                                            true,
                                                            2
                                                        );
                                                    },
                                                },
                                                {
                                                    title: "Frequency",
                                                    key: "Frequency",
                                                },
                                                {
                                                    title: "Paid from",
                                                    key: "PaidFrom",
                                                },
                                            ]}
                                        />
                                    ) : (
                                        <p className="mt-10 mb-10">
                                            No single payment(s) currently set up for this client
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-fluid col-equalise">
                        <div className="d-flex f-direction-column">
                            <h3 className="mb-5">Transfers</h3>
                            <div className="panel-subtle pt-0 pb-10 mb-20 f-grow-1">
                                <div>
                                    {props.activeTransferIn?.length > 0 ? (
                                        <Table
                                            cssWrapper="table-subtle table-first-last-cell-padding-reset mb-10"
                                            data={props.activeTransferIn}
                                            col={[
                                                {
                                                    title: "Ceding provider",
                                                    key: "Provider",
                                                },
                                                {
                                                    title: "Status",
                                                    key: "Status",
                                                    render: (data) => {
                                                        return TransferStatusMapper[data];
                                                    },
                                                },
                                                {
                                                    title: "Amount",
                                                    key: "Amount",
                                                    render: (data) => {
                                                        if (data === null) {
                                                            return "No amount recorded";
                                                        } else {
                                                            return MoneyDisplayHelper.FromatMoneyDisplay(
                                                                data,
                                                                CurrencyCode.GBP,
                                                                true,
                                                                2
                                                            );
                                                        }
                                                    },
                                                },
                                            ]}
                                        />
                                    ) : (
                                        <p className="mt-10 mb-10">No transfer(s) currently set up for this client</p>
                                    )}

                                    {props.activeTransferIn?.length > 0 &&
                                    checkPermission(UserClaim.AdviserPortalDluReregistrationTransfersCanView) ? (
                                        <a
                                            href={`/clients/tracking/reregistration-transfers.aspx?claccountid=${props.headAccount?.HeadClAccountId}&txtStatus=Open`}
                                            className="hyperlink"
                                        >
                                            {props.activeTransferIn?.length} pending transfer
                                        </a>
                                    ) : (
                                        <span>{props.activeTransferIn?.length} pending transfer</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                {lightBoxInfo.isShow && (
                    <Lightbox
                        show={lightBoxInfo.isShow}
                        title={"Are you sure you want to cancel all future regular payments?"}
                        contentAfterTitle={null}
                        onClose={() => {
                            setLightBoxInfo({
                                isShow: false,
                                amount: null,
                                frequency: null,
                                bankAccount: null,
                                nextPaymentDate: null,
                                cashEntryId: null,
                            });
                        }}
                        type={LightboxType.Modal}
                        unclosable={false}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        <table className="table-subtle table-first-last-cell-padding-reset has-first-cell-highlighted">
                            <tbody>
                                <tr>
                                    <th scope="row">Amount</th>
                                    <td className="cell-right">
                                        {MoneyDisplayHelper.FromatMoneyDisplay(
                                            lightBoxInfo.amount,
                                            CurrencyCode.GBP,
                                            true,
                                            2
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">Frequency</th>
                                    <td className="cell-right">{lightBoxInfo.frequency}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Bank account</th>
                                    <td className="cell-right">{lightBoxInfo.bankAccount}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Next payment</th>
                                    <td className="cell-right">{lightBoxInfo.nextPaymentDate}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="row row-center">
                            <div className="col-auto">
                                <button
                                    className="btn primary"
                                    onClick={() => {
                                        ProductOverviewPaymentsInAction.cancelRegularPaymentsIn(
                                            lightBoxInfo.cashEntryId,
                                            props.subAccountHierarchyId,
                                            (data) => {
                                                const splitDatum = splitData(data);
                                                setRegularPayment(splitDatum.regular);
                                                setLightBoxInfo({
                                                    isShow: false,
                                                    amount: null,
                                                    frequency: null,
                                                    bankAccount: null,
                                                    nextPaymentDate: null,
                                                    cashEntryId: null,
                                                });
                                            }
                                        );
                                    }}
                                >
                                    Yes
                                </button>
                            </div>
                            <div className="col-auto">
                                <button
                                    className="btn secondary"
                                    onClick={() => {
                                        setLightBoxInfo({
                                            isShow: false,
                                            amount: null,
                                            frequency: null,
                                            bankAccount: null,
                                            nextPaymentDate: null,
                                            cashEntryId: null,
                                        });
                                    }}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </Lightbox>
                )}
            </div>
            <Permission userClaim={UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite}>
                <SelectRegularPaymentPop
                    clientRegularPayment={selectClientRegular}
                    onClose={() => {
                        setSelectClientRegular([]);
                    }}
                    onSelect={(id) => window.location.assign(editRegularLink(id))}
                />
            </Permission>
        </>
    );
};
